<script setup lang="ts">
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

import IconClose from '~icons/lucide/x';

import KastenLogoLink from '../KastenLogoLink.vue';
import KSidebar from '../sidebar/KSidebar.vue';

const props = defineProps<{
  open: boolean;
}>();

const emit = defineEmits<{ close: [] }>();
</script>

<template>
  <TransitionRoot as="template" :show="props.open">
    <Dialog as="div" class="relative z-50 lg:hidden" @close="emit('close')">
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/40" />
      </TransitionChild>

      <div class="fixed inset-0 flex">
        <TransitionChild
          as="template"
          enter="transition ease-in-out duration-300 transform"
          enter-from="-translate-x-full"
          enter-to="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leave-from="translate-x-0"
          leave-to="-translate-x-full"
        >
          <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
            <TransitionChild
              as="template"
              enter="ease-in-out duration-300"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="ease-in-out duration-300"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                <button
                  type="button"
                  class="-m-2.5 rounded-full p-2.5 text-white focus-visible:outline-2 focus-visible:outline-blue-400"
                  @click="emit('close')"
                  id="mobileMenuCloseButton"
                >
                  <span class="sr-only">Close sidebar</span>
                  <IconClose class="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </TransitionChild>
            <!-- SIDEBAR -->
            <div
              class="flex grow flex-col border-r border-gray-100 bg-white dark:border-navy-600 dark:bg-navy-950"
            >
              <KastenLogoLink />
              <KSidebar mobile />
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>

  <!-- STATIC DESKTOP SIDEBAR: Logo (appears first in tab order) -->
  <nav
    aria-label="Veeam Kasten home"
    class="hidden border-r border-gray-100 bg-white dark:border-navy-600 dark:bg-navy-950 lg:fixed lg:left-0 lg:top-0 lg:z-50 lg:flex lg:w-72 lg:flex-col"
  >
    <KastenLogoLink />
  </nav>
</template>
